import { render, staticRenderFns } from "./SalesByItem.vue?vue&type=template&id=58cb6acc&scoped=true"
import script from "./SalesByItem.vue?vue&type=script&lang=js"
export * from "./SalesByItem.vue?vue&type=script&lang=js"
import style0 from "./SalesByItem.vue?vue&type=style&index=0&id=58cb6acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb6acc",
  null
  
)

export default component.exports